// Centralized data-testid keys for the whole app
export const NAV = {
  logo: "navbar-logo-link",
  home: "nav-home-link",
  capacitaciones: "nav-capacitaciones-link",
  conferencias: "nav-conferencias-link",
  consultorias: "nav-consultorias-link",
  desarrollo: "nav-desarrollo-link",
  contacto: "nav-contacto-link",
  cta: "nav-cta-btn",
  themeToggle: "theme-toggle-btn",
  langToggle: "lang-toggle-btn",
  mobileMenu: "mobile-menu-btn",
};

export const HOME = {
  heroPrimary: "home-hero-primary-cta",
  heroSecondary: "home-hero-secondary-cta",
  statValue: (i) => `home-stat-value-${i}`,
  serviceCard: (i) => `home-service-card-${i}`,
  finalCta: "home-final-cta-btn",
  emergentLink: "home-emergent-link",
};

export const FORM = {
  name: "lead-form-name-input",
  company: "lead-form-company-input",
  email: "lead-form-email-input",
  phone: "lead-form-phone-input",
  service: "lead-form-service-select",
  message: "lead-form-message-input",
  submit: "lead-form-submit-btn",
  success: "lead-form-success-msg",
  error: "lead-form-error-msg",
};

export const WHATSAPP = "floating-whatsapp-btn";
